export default function HowToPurchaseData() {

    return {
        title: 'How to Purchase',
        paragraphs: [`<div>Morgan Stanley requires all Financial Advisors to review Disability Insurance Illustrations with their clients. Please request illustrations from our approved carriers below.<div>`,
        `<br/><div><b>Please select one:</b></div>`,
        `<ul class="mt-2 mb-0">
        <li class="pl-2">To request Principal Disability illustration via Phone / Email, <a class="redirect-link" id="disability-link">CLICK HERE</a>.</li>
        <li class="pl-2">To request Guardian Disability illustration via Phone / Email, <a href="https://wm3dr.ms.com/pub/content/dam/wm3dr/documents/insurance/Guardian%20-%20Morgan%20Stanley%20Branch%20List%20.xlsx" target='_blank'>CLICK HERE</a>.</li>
        <li class="pl-2">To request Mass Mutual Disability illustration via Phone / Email, <a class="redirect-link" id="mass-mutual-disability-link">CLICK HERE</a>.</li></ul>`,
        `<div>For any questions regarding Morgan Stanley’s Licensing Policy, <a href="http://mssbintranet.msdwis.com/uiplsds/app-bin/intranetsolution/Operations/General/Insurance/INS_Licensing.page?" target='_blank'>CLICK HERE</a>.</div>
        <br/><div>To view your current Licenses and Appointments on the Insurance Licensing Tool (ILT) <a class="redirect-link" id='navigate-to-appointment-link'}>CLICK HERE</a>.</div>`,
        ],
        linkId: "disability-link",
        massMutualLinkId: "mass-mutual-disability-link",
        navigateToAppointmentLinkId:'navigate-to-appointment-link',
        onLinkClick: () => {
          window.open("https://wm3dr.ms.com/pub/content/wm3dr/basepage/insurance/document-pages/Principal-DI-wholesaler-coverage-map.html", 'newwindow', 'width=600,height=400');
        },
        onMassMutualLinkClick: () => {
            window.open("https://wm3dr.ms.com/pub/content/wm3dr/basepage/insurance/document-pages/MMSD-National-LI-and-DI-Territory-Maps.html", 'newwindow', 'width=600,height=400');
        },
        NavigateToAppointmentLinkClick:()=>{
            var mswm = window.mswm;
            if (mswm) {
                console.log("mswm found");
                if (mswm.ast && mswm.ast.udjsapi && mswm.ast.udjsapi.environment
                    && mswm.ast.udjsapi.environment.isUdContainerAvailable()) {
                    console.log("redirecting to 99723");
                    mswm.ast.udjsapi.navigator.navigate("99723", {
                      AdditionalParams: {
                        hasUdjsRef: "false"
                      }
                    });

                }
            }
            else {
                console.log("mswm not found");
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/Common/data/products/disability-insurance/HowToPurchaseData.js